export const UI2Colors = {
  GREEN_50: 'green-50',
  GREEN_100: 'green-100',
  GREEN_800: 'green-800',
  GREEN_900: 'green-900',
  BLUE_50: 'blue-50',
  BLUE_100: 'blue-100',
  BLUE_800: 'blue-800',
  BLUE_900: 'blue-900',
  AMBER_50: 'amber-50',
  AMBER_100: 'amber-100',
  AMBER_900: 'amber-900',
  RED_50: 'red-50',
  RED_100: 'red-100',
  RED_800: 'red-800',
  RED_900: 'red-900',
  GREY_100: 'grey-100',
  GREY_200: 'grey-200',
  GREY_800: 'grey-800',
  GREY_900: 'grey-900',

  DARK_BLACK: 'dark-black',
  LIGHT_BLACK: 'light-black',
  WHITE: 'white',
  DARK_WHITE: 'dark-white',
} as const

export type UI2ColorName = (typeof UI2Colors)[keyof typeof UI2Colors]

export const UI2_COLOR_NAMES: UI2ColorName[] = Object.values(UI2Colors)
export interface UI2ColorTreatment {
  background?: UI2ColorName
  foreground?: UI2ColorName
  border?: UI2ColorName
}
